export enum Country {
    DE = 'DE',
    DK = 'DK',
    EE = 'EE',
    FI = 'FI',
    GB = 'GB',
    IS = 'IS',
    LT = 'LT',
    LV = 'LV',
    NO = 'NO',
    PL = 'PL',
    SE = 'SE',
}

export enum Currency {
    DKK = 'DKK',
    EUR = 'EUR',
    GBP = 'GBP',
    ISK = 'ISK',
    NOK = 'NOK',
    PLN = 'PLN',
    SEK = 'SEK',
}

export enum Unit {
    KILOWATTHOUR = 'kWh',
    MONTHLY = 'month',
    MINUTE = 'min',
    HOUR = 'h',
}

export enum CurrencyPosition {
    PREFIX = 'PREFIX',
    SUFFIX = 'SUFFIX',
}
